import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e27bfba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "buts" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("创建二维码")
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("测试链接")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("数据分析")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "请在微信环境下，扫码查看详情", -1))

import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router'
import { InfoFilled } from '@element-plus/icons-vue'
import { advList, deleteAdv,copyAdv } from '../config/interface'
import { ElMessage } from 'element-plus'
import QrcodeVue from 'qrcode.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// 相关引入
const util = require('../utils/util')

// 响应式数据、props、emit 定义
const pageTotal = ref(0)
const coping = ref(false)
const tableData = ref([])
const router = useRouter()
const qrObj = ref<any>({})
const showQrCode = ref(false)
const pageNum = ref(1)

// 方法定义
const goEdit = (id: number) => {
  router.push({
    path: '/edit',
    query: { id: id }
  })
}
const createQrcode = ((obj:any)=>{
  qrObj.value.qrName = obj.advName
  qrObj.value.qrCodeId = obj.id
  showQrCode.value = true
})
const goAnalysis = (id: number) => {
  router.push({
    path: '/analysis',
    query: { id: id }
  })
}
const confirmEvent = (id: Number) => {
  let params = {
    id: id
  }
  deleteAdv(params).then(res => {
    if (res.data.success) {
      ElMessage.success(res.data.msg)
      getAvdList()
    } else {
      ElMessage.error(res.data.msg)
    }
  })
}
const copy = ((id:number)=>{
  let params = {
      aId:id
  }
  coping.value = true
  copyAdv(params).then(res => {
      if(res.data.success){
          ElMessage.success(res.data.msg)
          getAvdList()
      }else{
          ElMessage.error(res.data.msg)
      }
      coping.value = false
  })
})
const getAvdList = (()=>{
  let params = {
    pageNum: pageNum.value,
    advName: ''
  }
  advList(params).then(res => {
    tableData.value = res.data.data.list
    pageTotal.value = res.data.data.total
  })
})
const currentChange = ((num:number)=>{
  pageNum.value = num
  getAvdList()
})

// 生命周期以及 watch 书写
onMounted(() => {
  getAvdList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goEdit(0)))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        stripe: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "序号",
            width: "80",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "advName",
            label: "渠道名称",
            width: "240",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "scanTotal",
            label: "扫码总次数",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "userNum",
            label: "扫码总人数",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间",
            width: "180",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(util).formatTimer(scope.row.createTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "option",
            label: "操作",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (goEdit(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                title: "确定要删除？",
                icon: _unref(InfoFilled),
                "icon-color": "red",
                "confirm-button-text": "确定",
                "cancel-button-text": "取消",
                onConfirm: ($event: any) => (confirmEvent(scope.row.id))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["icon", "onConfirm"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (copy(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_loading, coping.value]
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (createQrcode(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (scope.row.proId !== 0)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (goAnalysis(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        total: pageTotal.value,
        onCurrentChange: currentChange
      }, null, 8, ["total"])
    ]),
    (showQrCode.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dialog-w",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showQrCode.value = false))
        }, [
          _createElementVNode("div", {
            class: "dialog",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", null, _toDisplayString(qrObj.value.qrName), 1),
            _createVNode(QrcodeVue, {
              value: 'http://qrcode.yoyolooming.com/?aId='+qrObj.value.qrCodeId,
              size: 200,
              level: "H"
            }, null, 8, ["value"]),
            _hoisted_10
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})